import { jsxs as x, jsx as s } from "react/jsx-runtime";
import { forwardRef as y, isValidElement as A, cloneElement as N } from "react";
import { F as g, f as w, c as E, a as h, b as j, e as v, d as C } from "./Field-BUxMseAe.js";
import { c as I } from "./cn-DlLpp5ix.js";
const k = y(function({
  name: l,
  label: n,
  description: a,
  hint: r,
  error: i,
  action: m,
  required: t = !1,
  disabled: d = !1,
  layout: o = "stacked",
  children: f,
  className: c,
  id: p,
  asChild: F = !1
}, u) {
  const b = I(
    o === "inline" && "sm:grid sm:grid-cols-[minmax(0,1fr)_minmax(0,2fr)] sm:items-start sm:gap-x-4",
    c
  );
  return /* @__PURE__ */ x(
    g,
    {
      ref: u,
      id: p,
      invalid: !!i,
      disabled: d,
      required: t,
      "data-ls-composite": "field-assembly",
      "data-layout": o,
      className: b,
      children: [
        /* @__PURE__ */ s(w, { children: n }),
        a ? /* @__PURE__ */ s(E, { children: a }) : null,
        m ? /* @__PURE__ */ s(h, { children: m }) : null,
        /* @__PURE__ */ s(j, { asChild: F, children: B(f, l) }),
        r ? /* @__PURE__ */ s(v, { children: r }) : null,
        i ? /* @__PURE__ */ s(C, { children: i }) : null
      ]
    }
  );
});
k.displayName = "FieldAssembly";
function B(e, l) {
  return !l || !A(e) || e.props.name !== void 0 ? e : N(e, { name: l });
}
export {
  k as F
};
//# sourceMappingURL=FieldAssembly-CJ8dCXil.js.map
